import React from "react";
import { RFxMailLayout } from "./components/RFxMailLayout";
import { EmailContentProps } from "./types/EmailContent.interface";
import { AdditionalMessageDisplay } from "./components/AdditionalMessageDisplay";
import {
	DecisionFile,
	DecisionFilesDisplay,
} from "./components/DecisionFilesDisplay";

export interface SubmissionSuccessfulEmailContentProps
	extends EmailContentProps {
	/** Decision attachments to mirror the real award email. Optional. */
	decisionFiles?: DecisionFile[];
}

export const SubmissionSuccessfulEmailContent = ({
	rfxMail,
	decisionFiles,
}: SubmissionSuccessfulEmailContentProps) => {
	const emailData = rfxMail?.emailData;

	if (!emailData) {
		return null;
	}

	const $owner_company_name = emailData.owner_company_name;
	const $supplier_name = emailData.supplier_name;
	const $rfx_type = emailData.rfx_type;
	const $additional_message = emailData.additional_message;
	const type_project = rfxMail.rfx_type_name_project_name();
	const $is_guest = rfxMail.is_guest;

	return (
		<RFxMailLayout
			$supplier_contact_name={emailData.supplier_contact_name}
			$contact={emailData.contact}
			rfx_type={emailData.rfx_code}
			project_name={emailData.project_name}
			rfx_title={emailData.rfx_title}
		>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					We are delighted to{" "}
					{$is_guest
						? "let you know that you’ve"
						: "inform you that " +
							($supplier_name ?? "Supplier_name") +
							" has"}{" "}
					been selected as the preferred service provider on the {type_project}
					.
				</td>
			</tr>
			<AdditionalMessageDisplay additional_message={$additional_message} />
			<DecisionFilesDisplay decisionFiles={decisionFiles} />
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					A representative from {$owner_company_name} will be in touch with you
					shortly to discuss the next steps.
				</td>
			</tr>
			<tr>
				<td>
					<table>
						<tr>
							<td width="33%"></td>
							<td
								style={{
									backgroundColor: "#003CE9",
									borderRadius: "4px",
									textAlign: "center",
								}}
								width="66%"
							>
								<a
									href="{{ $rfx_url ?? config('app.frontend_url') }}"
									style={{
										display: "inline-block",
										padding: "12px 24px",
										color: "#ffffff",
										fontFamily: "Arial, sans-serif",
										fontSize: "16px",
										textDecoration: "none",
									}}
								>
									View this {$rfx_type}
								</a>
							</td>
							<td width="33%"></td>
						</tr>
					</table>
					<br />
				</td>
			</tr>
		</RFxMailLayout>
	);
};
